{
  "default_chapter_title": "Chapter 1",
  "request_failed": "Request failed. Please try again.",
  "log_out": "Log Out",
  "logout_dialog_text": "Are you sure you want to logout from your account?",
  "delete": "Delete",
  "delete_account": "Delete account",
  "delete_account_dialog_text": "Are you sure you want to delete your account?",
  "delete_dialog_text": "Are you sure you want to delete your ",
  "please_note": "Please note!",
  "confirm_change_password": "You will be automatically logged out from all your devices after changing your password.",
  "failed_upload_image": "Failed to upload image.",
  "failed_delete_facet": "Failed to delete facet.",
  "failed_create": "Failed to create",
  "failed_update": "Failed to update",
  "menu_my_stories": "My Stories",
  "menu_friends": "My friends",
  "menu_dashboard": "Dashboard",
  "menu_setings": "Settings",
  "menu_replay_tour": "Replay tour",
  "menu_get_in_touch": "Get in touch",
  "menu_faqs": "FAQs",
  "menu_privacy": "Privacy Policy",
  "terms": "Terms & Conditions"
}
